export const snapshotResultsMock = {
  systemHeader: {
    region: 'us-west-1',
    datetime: Date.now(),
    sessionId: 'debug-session-id',
    schemaVersion: '1.0.0',
    dataVersion: '1.0.0'
  },
  eventHeader: {
    eventId: 'debug-event-id',
    eventName: 'snapshot-results',
    publisher: 'debug-app',
    subscribers: ['platform'],
    publisherInstanceId: 'debug-instance'
  },
  data: {
    snapshots: [
      {
        data: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjOHLkyH8AB+gDTOQq89IAAAAASUVORK5CYII=',
        mimeType: 'image/png',
        metadata: {
          assessments: [
            'tooth-health'
          ],
          'color-spectrum': [
            'x-ray',
            'niri',
            'white-light',
            'stone-model'
          ],
          jaws: ['upper', 'lower'],
          observations: {
            occlusogram: {
              teeth: [
                11, 12, 13, 14, 25, 26, 27, 28, 31, 32, 36, 37, 38, 41,
                42, 43, 44
              ]
            },
            caries: {
              teeth: [
                11, 12, 13, 14, 25, 26, 27, 28, 31, 32, 36, 37, 38, 41,
                42, 43, 44
              ]
            }
          },
          'capture-time': '2025-01-01T00:00:00Z',
          permalink: 'https://example.com/permalink',
          'is-app-screenshot': true,
          'capture-app': {
            id: 'iosimplus-ui'
          }
        }
      }
    ]
  }
};
